import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { KoobButton, KoobCard } from '@koob/ui';
import { Container, Text } from 'ui';
import DetailsSettingRequestForm from 'components/Forms/DetailsSettingRequestForm';
import ToConnectionRequestState from 'components/ToConnectionRequestState';
import { getSettingRequest } from 'api/node/settingRequests';
import { useAsync } from 'react-async';

const DetailsSettingRequest = () => {
  const { settingRequestId } = useParams();
  const { t } = useTranslation('settingRequest');
  const { data } = useAsync({
    promiseFn: getSettingRequest,
    settingRequestId,
  });

  const request = data?.data;

  return (
    <>
      <div className="px-4">
        <div className="bg-white border rounded-lg p-10">
          <div className="flex justify-center">
            <div className="flex gap-4 text-black text-3xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-10 h-10"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5.32894 3.27158C6.56203 2.8332 7.99181 3.10749 8.97878 4.09446C9.96603 5.08171 10.2402 6.51202 9.80129 7.74535L20.646 18.5902L18.5247 20.7115L7.67887 9.86709C6.44578 10.3055 5.016 10.0312 4.02903 9.04421C3.04178 8.05696 2.76761 6.62665 3.20652 5.39332L5.44325 7.63C6.02903 8.21578 6.97878 8.21578 7.56457 7.63C8.15035 7.04421 8.15035 6.09446 7.56457 5.50868L5.32894 3.27158ZM15.6963 5.15512L18.8783 3.38736L20.2925 4.80157L18.5247 7.98355L16.757 8.3371L14.6356 10.4584L13.2214 9.04421L15.3427 6.92289L15.6963 5.15512ZM8.62523 12.9333L10.7465 15.0546L5.7968 20.0044C5.21101 20.5902 4.26127 20.5902 3.67548 20.0044C3.12415 19.453 3.09172 18.5793 3.57819 17.99L3.67548 17.883L8.62523 12.9333Z"
                />
              </svg>
            </div>
          </div>

          <div className="text-center">
            <Text type="h1">{t('settingDetails')}</Text>
          </div>

          <div className="mt-4 flex justify-center">
            <ToConnectionRequestState state={request?.state} />
          </div>
        </div>
        <div className="my-5 flex justify-end gap-5">
          <KoobButton type="button" variant="secondary" asChild>
            <Link to={-1}>{t('misc:cancel')}</Link>
          </KoobButton>
        </div>

        <Container size="full">
          <KoobCard>
            <DetailsSettingRequestForm settingRequest={request} />
          </KoobCard>
        </Container>
      </div>
    </>
  );
};

export default DetailsSettingRequest;
